import { useQuery, useMutation } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { MutationEffectsOptions, useMutationEffects } from "@/data/useMutationEffects";
import { AppQueryOptions, AppMutationOptions } from "@povio/openapi-codegen-cli";
import { UserModels } from "./user.models";
import { UserApi } from "./user.api";

export namespace UserQueries {

export const moduleName = QueryModule.User;

export const keys = {
    all: [moduleName] as const,
    get: () => [...keys.all, "/user/me", ] as const,
    getNotificationPreferences: () => [...keys.all, "/user/me/notification-preferences", ] as const,
};


 /** 
 * Query `useGet`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<UserModels.UserAccountResponse> } 
 * @statusCodes [200, 401]
 */
export const useGet = <TData>(options?: AppQueryOptions<typeof UserApi.get, TData>) => {
  
  
  return useQuery({
    queryKey: keys.get(),
    queryFn: UserApi.get
    ,
    ...options,
  });
};






 /** 
 * Query `useGetNotificationPreferences`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<UserModels.NotificationPreferencesResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useGetNotificationPreferences = <TData>(options?: AppQueryOptions<typeof UserApi.getNotificationPreferences, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getNotificationPreferences(),
    queryFn: UserApi.getNotificationPreferences
    ,
    ...options,
  });
};








 /** 
 * Mutation `useUpdateNotificationPreferences`
 * @param { UserModels.UpdateNotificationPreferencesDto } mutation.data Body parameter
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<UserModels.NotificationPreferencesResponseDto> } 
 * @statusCodes [200, 401]
 */
export const useUpdateNotificationPreferences = (options?: AppMutationOptions<typeof UserApi.updateNotificationPreferences, { data: UserModels.UpdateNotificationPreferencesDto,  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: ( { data } ) => 
      
            UserApi.updateNotificationPreferences(data)
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      
      const updateKeys = [keys.getNotificationPreferences(), ];
      await runMutationEffects(resData, options, updateKeys);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};







 /** 
 * Mutation `useVerifySignin`
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<UserModels.UserAccountResponse> } 
 * @statusCodes [201, 401]
 */
export const useVerifySignin = (options?: AppMutationOptions<typeof UserApi.verifySignin, {  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: () => 
      
            UserApi.verifySignin()
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      
      const updateKeys = [keys.get(), ];
      await runMutationEffects(resData, options, updateKeys);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};







 /** 
 * Mutation `useVerifySignup`
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<UserModels.UserAccountResponse> } 
 * @statusCodes [201, 401]
 */
export const useVerifySignup = (options?: AppMutationOptions<typeof UserApi.verifySignup, {  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: () => 
      
            UserApi.verifySignup()
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      
      const updateKeys = [keys.get(), ];
      await runMutationEffects(resData, options, updateKeys);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};







 /** 
 * Mutation `useVerifySSO`
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<UserModels.UserAccountResponse> } 
 * @statusCodes [201, 401]
 */
export const useVerifySSO = (options?: AppMutationOptions<typeof UserApi.verifySSO, {  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: () => 
      
            UserApi.verifySSO()
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      
      const updateKeys = [keys.get(), ];
      await runMutationEffects(resData, options, updateKeys);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};





}
